import axios from 'axios';

// URL da API - usa variável de ambiente em produção ou localhost em desenvolvimento
const API_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? '/api'  // Em produção, usa o mesmo domínio (proxy ou subdomínio)
    : 'http://localhost:5000/api');  // Desenvolvimento local

export const api = axios.create({
  baseURL: API_URL
});

// Interceptor para definir Content-Type apenas quando não for FormData
api.interceptors.request.use((config) => {
  if (!(config.data instanceof FormData)) {
    config.headers['Content-Type'] = 'application/json';
  }
  return config;
});

// Interceptor para adicionar token em todas as requisições
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

